import { render, staticRenderFns } from "./contentType.vue?vue&type=template&id=56493f21&scoped=true"
import script from "./contentType.vue?vue&type=script&lang=js"
export * from "./contentType.vue?vue&type=script&lang=js"
import style0 from "./contentType.vue?vue&type=style&index=0&id=56493f21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56493f21",
  null
  
)

export default component.exports